import Box from '@mui/material/Box';
import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
// import { background } from "src/styles";
import R1 from '../assets/svgs/R1.png';

export const RoadCard = (props: any) => {
  return (
    console.log(props.background, 'backgroundImage'),
    (
      <Box display="flex" flexDirection="column" marginX={1}>
        <Box margin={2}>
          
          {props.q}
          
          </Box>
        <Box
          bgcolor={'#141420'}
          height={{lg:471, xs: 465}}
          width={{lg: 445, xs:320}}
          display="flex"
          flexDirection="column"
          p={{lg: 5, xs: 1}}
          // style={{ borderRadius: 10 }}
          style={{
            backgroundImage: `url(${props.background})`,
            borderRadius: 10,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain'
          }}
        >
          <Box minHeight={{lg:100, xs:25}} paddingY={{xs:5, lg:0}} display="flex" flexDirection="column" mb={2}>
            {props.title}
          </Box>
          <Box
            // height={300}
            display="flex"
            flexDirection="column"
            
            // justifyContent="center"
            // alignItems="center"
          >
            {props.para}
          </Box>
        </Box>
      </Box>
    )
  );
};
